export const openUrlInTelegram = (url: string): void => {
  if (window.Telegram && window.Telegram.WebApp)
    window.Telegram.WebApp.openLink(url); // Open URL using Telegram's built-in method
  else window.open(url, '_blank'); // Fallback for non-Telegram environments (development, etc.)
};
